import type { App } from 'vue';
import { DtTooltipDirective } from '@dialpad/dialtone/vue3/lib/tooltip-directive';
export function hostDirectives({ vueApp }: { vueApp: App }): void {
  vueApp.use(DtTooltipDirective);
}
